import React, { FC } from 'react';
import { Box } from '@mui/material';
import { LabClient } from 'models/client-directory';
import InfoBySupplier from './info-by-supplier/info-by-supplier.components';

type ConnectedSupplierContactProps = {
    labClient: LabClient;
};
const ConnectedSupplierContact: FC<ConnectedSupplierContactProps> = ({ labClient }: ConnectedSupplierContactProps) => {
    return (
        <Box sx={{ maxWidth: 900 }}>
            <Box mb={1}>
                <InfoBySupplier labClient={labClient} />
            </Box>
        </Box>
    );
};

export default ConnectedSupplierContact;
